import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { ThemeProvider } from "./contexto/ThemeProvider";
import Home from "./paginas/Home";
import DashboardImobiliario from "./paginas/DashboardImobiliario";
import AssistenteImobiliario from "./paginas/AssistenteImobiliario";
import NeonFinancas from "./paginas/NeonFinancas";
import ComparadorImoveis from "./paginas/ComparadorImoveis";
import DiarioMotorista from "./paginas/DiarioMotorista";
import PrevisaoTempo from "./paginas/PrevisaoTempo";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard-imobiliario" element={<DashboardImobiliario />} />
          <Route path="/assistente-ia" element={<AssistenteImobiliario />} />
          <Route path="/neon" element={<NeonFinancas />} />
          <Route path="/comparador" element={<ComparadorImoveis />} />
          <Route path="/diario" element={<DiarioMotorista />} />
          <Route path="/previsao" element={<PrevisaoTempo />} />
        </Routes>
        <Analytics />
      </Router>
    </ThemeProvider>
  );
}

export default App;
